import type { LucideIcon } from 'lucide-react';
import { nodeIcon, nodeTone } from '@/components/value-chain/nodeVisuals';
import type { ValueChainNode } from '@/types/valueChain';

type Props = {
  node: ValueChainNode;
  size?: 'sm' | 'md' | 'lg';
};

const SIZE = {
  sm: 'h-9 w-9',
  md: 'h-11 w-11',
  lg: 'h-14 w-14',
};

export function NodeThumb({ node, size = 'md' }: Props) {
  const Icon: LucideIcon = nodeIcon(node);
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-xl ${SIZE[size]} ${nodeTone(node)}`}
      aria-hidden
    >
      <Icon className={size === 'lg' ? 'h-6 w-6' : 'h-4 w-4'} />
    </span>
  );
}
